import script from "./institutionManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./institutionManagement.vue?vue&type=script&setup=true&lang=js"

import "./institutionManagement.vue?vue&type=style&index=0&id=dc30a2ce&lang=scss"

const __exports__ = script;

export default __exports__